import React, { Component } from 'react';
import './App.css';
import loadable from '@loadable/component'
import { Route, Switch } from 'react-router-dom'
import Loading from './common-components/loading'
import 'antd-mobile/dist/antd-mobile.min.css'
import { map } from 'lodash';

const LoadableIndex = loadable(() => import('./pages/index'), {
  fallback: <Loading />
})

const NoFound = loadable(() => import('./pages/no-found'), {
  fallback: <Loading />
})

//app升级活动弹窗
const LoadableUpgradePop = loadable(() => import('./pages/upgrade-pop/upgrade-pop'), {
  fallback: <Loading />
})

//升级活动详情页
const LoadableUpgradeDetail = loadable(() => import('./pages/upgrade-pop/upgrade-detail'), {
  fallback: <Loading />
})

//谷歌浏览器下载页面
const LoadableBrowserDownload = loadable(() => import('./pages/browser-download/browser-download'), {
  fallback: <Loading />
})

//活动失效页
const LoadableOverdueActivity = loadable(() => import('./pages/overdue-activity/overdue-activity'), {
  fallback: <Loading />
})

//预习页面
const LoadableCoursePreview = loadable(() => import('./pages/course-preview/course-preview'), {
  fallback: <Loading />
})

//修改收获地址页面
const LoadableAddress = loadable(() => import('./pages/address/address'), {
  fallback: <Loading />
})

//使用课时页面
const LoadableCourseStatus = loadable(() => import('./pages/course-status/course-status'), {
  fallback: <Loading />
})

//预开课时页面
const LoadablePreCourseStatus = loadable(() => import('./pages/pre-course-status/pre-course-status'), {
  fallback: <Loading />
})

//数据看板：首页
const LoadableTeacherDataBoard = loadable(() => import('./pages/teacher-data-board/index'), {
  fallback: <Loading />
})

//数据看板：课时统计详情页
const LoadableClassTime = loadable(() => import('./pages/teacher-data-board/class-time/class-time'), {
  fallback: <Loading />
})

const LoadableDemoCardDetail = loadable(() => import('./pages/teacher-data-board/demoCardDetail/index'), {
  fallback: <Loading />
})

//数据看板：点评率详情页
const LoadableReviewRate = loadable(() => import('./pages/teacher-data-board/review-rate/review-rate'), {
  fallback: <Loading />
})

//数据看板：课堂满意度详情页
const LoadableClassSatisfaction = loadable(() => import('./pages/teacher-data-board/class-satisfaction/class-satisfaction'), {
  fallback: <Loading />
})

//数据看板：反馈详情页
const LoadableFeedbackRate = loadable(() => import('./pages/teacher-data-board/feedback-rate/feedback-rate'), {
  fallback: <Loading />
})

//数据看板：准时出勤率页面
const LoadableAttendanceRate = loadable(() => import('./pages/teacher-data-board/attendance-rate/attendance-rate'), {
  fallback: <Loading />
})
//预开课时页面
const LoadableCourseReview = loadable(() => import('./pages/course-review/course-review.jsx'), {
  fallback: <Loading />
})

//预开课时页面
const LoadableRecordVideo = loadable(() => import('./pages/record-video/record-video.jsx'), {
  fallback: <Loading />
})

const LoadableTest = loadable(() => import('./pages/test/index.js'), {
  fallback: <Loading />
})
const testV2 = loadable(() => import('./pages/testV2'), {
  fallback: <Loading />
})
//画啦啦隐私政策
const LoadablePrivacyArgreement = loadable(() => import('./pages/privacy-agreement/privacy-agreement'), {
  fallback: <Loading />
})
//画啦啦隐私政策
const LoadablePrivacyArgreementOs = loadable(() => import('./pages/privacy-agreement-os/privacy-agreement'), {
  fallback: <Loading />
})
//画啦啦隐私政策
const LoadablePrivacyArgreementOversea = loadable(() => import('./pages/privacy-agreement-oversea/privacy-agreement'), {
  fallback: <Loading />
})
const LoadablePrivacyArgreement2 = loadable(() => import('./pages/privacy-agreement2/privacy-agreement'), {
  fallback: <Loading />
})

//作业移交-离职老师名单
const LoadableTeacherList = loadable(() => import('./pages/homework-transfer/teacher-list/teacher-list.js'), {
  fallback: <Loading />
})
//作业移交-移交页面
const LoadableTransferOperation = loadable(() => import('./pages/homework-transfer/transfer-operation/transfer-operation.js'), {
  fallback: <Loading />
})

//数据看板：课时统计详情二级页面
const LoadableClassTimeDetail = loadable(() => import('./pages/teacher-data-board/class-time-detail/class-time-detail.js'), {
  fallback: <Loading />
})
//数据看板：点评及时率详情二级页面
const LoadableReviewRateDetail = loadable(() => import('./pages/teacher-data-board/review-rate-detail/review-rate-detail.js'), {
  fallback: <Loading />
})
//数据看板：出勤率率详情二级页面
const LoadableAttendanceRateDetail = loadable(() => import('./pages/teacher-data-board/attendance-rate-detail/attendance-rate-detail.js'), {
  fallback: <Loading />
})
//数据看板：课堂满意度详情二级页面
const LoadableSatisfactionDetail = loadable(() => import('./pages/teacher-data-board/class-satisfaction-detail/class-satisfaction-detail.js'), {
  fallback: <Loading />
})
//数据看板：反馈填写率详情二级页面
const LoadableFeedbackRateDetail = loadable(() => import('./pages/teacher-data-board/feedback-rate-detail/feedback-rate-detail.js'), {
  fallback: <Loading />
})
//意见反馈页面
const LoadableSuggestion = loadable(() => import('./pages/class-suggestion/class-suggestion.js'), {
  fallback: <Loading />
})

//网络检测页面
const LoadableNetWorkTest = loadable(() => import('./pages/network-test'), {
  fallback: <Loading />
})
const LoadableLiveAdminRecordVideo = loadable(() => import('./pages/live-admin-video/record-video-new'), {
  fallback: <Loading />
})
// 课时详情首页 - 兼容APP-旧版本的路径
const LoadableCourseTime = loadable(() => import('./pages/course-time-detail/index'), {
  fallback: <Loading />
})
// 课时详情-详情页
const LoadableCourseTimeDetail = loadable(() => import('./pages/course-time-detail/detail'), {
  fallback: <Loading />
})
// 课时详情-规则页
const LoadableCourseTimeRule = loadable(() => import('./pages/course-time-detail/rule'), {
  fallback: <Loading />
})

// 查看备课页面
const coursewareViewer = loadable(() => import('./pages/courseware-viewer/index'), {
  fallback: <Loading />
})
// 移动端的全屏课件页面
const coursewareFullScreen = loadable(() => import('./pages/courseware-fullscreen/index'), {
  fallback: <Loading />
})
// 移动端的全屏word文档页面
const coursewareFullScreenToWord = loadable(() => import('./pages/courseware-fullscreenToWord/index'), {
  fallback: <Loading />
})
const ExcellentHomework = loadable(() => import('./pages/excellent-homework/index'), {
  fallback: <Loading />
})
const addressV2 = loadable(() => import('./pages/addressV2/address'), {
  fallback: <Loading />
})
const customerService = loadable(() => import('./pages/customer-service'), {
  fallback: <Loading />
})
const userAgreement = loadable(() => import('./pages/user-agreement/index'), {
  fallback: <Loading />
})
const userAgreementOversea = loadable(() => import('./pages/user-agreement-oversea/index'), {
  fallback: <Loading />
})
const coupon = loadable(() => import('./pages/coupon'), {
  fallback: <Loading />
})
const parentsClass = loadable(() => import('./pages/parents-class'), {
  fallback: <Loading />
})
const commonQuestion = loadable(() => import('./pages/common-question'), {
  fallback: <Loading />
})

// 扩展活动页面
const expandZoneEntry = loadable(() => import('./pages/expand-zone/entry'), {
  fallback: <Loading />
})
const expandZoneHome = loadable(() => import('./pages/expand-zone/home'), {
  fallback: <Loading />
})
const expandZoneOfter = loadable(() => import('./pages/expand-zone/ofter-page'), {
  fallback: <Loading />
})
const appTestPage = loadable(() => import('./pages/expand-zone/apptest'), {
  fallback: <Loading />
})

// 引导关注页面-正式课&体验课
const guideBindPageToVip = loadable(() => import('./pages/guideBindWxServer/vip'), {
  fallback: <Loading />
})
const guideBindPageToMember = loadable(() => import('./pages/guideBindWxServer/member'), {
  fallback: <Loading />
})

const expandZoneHomeRoutes = () => {
  const list = [1, 2, 3, 4, 5];
  return list.map((page, index) => {
    return <Route path={`/expandZone/home/${page}`} key={`expandZoneHome${index}`} component={expandZoneHome} />
  })
}
const ImageTemplatePage = loadable(() => import('./pages/image-template/index'), {
  fallback: <Loading />
})

const AppDownload = loadable(() => import('./pages/app-download/index'), {
  fallback: <Loading />
})

const ServiceAgreement = loadable(() => import('./pages/service-agreement/index'), {
  fallback: <Loading />
})

// 新版画啦啦点评app数据看板
//数据看板：首页
const DataBoardV2TeacherDataBoard = loadable(() => import('./pages/teacher-data-board-v2/index'), {
  fallback: <Loading />
})
// tableDemo
const DataBoardV2TableDemo = loadable(() => import('./pages/teacher-data-board-v2/tableDemo'), {
  fallback: <Loading />
})
// 班级信息
const DataBoardV2ClassMessage = loadable(() => import('./pages/teacher-data-board-v2/class-message/index'), {
  fallback: <Loading />
})
// 班级详情
const DataBoardV2ClassMessageTeacher = loadable(() => import('./pages/teacher-data-board-v2/class-message-teacher/index'), {
  fallback: <Loading />
})
// 学员信息
const DataBoardV2StudentMessage = loadable(() => import('./pages/teacher-data-board-v2/student-message'), {
  fallback: <Loading />
})
//教学服务看板：课时统计详情页-全部老师
const DataBoardV2ClassTime = loadable(() => import('./pages/teacher-data-board-v2/class-time/class-time.jsx'), {
  fallback: <Loading />
})

//教学服务看板：课时统计详情页-单个老师
const DataBoardV2ClassTimeTeacher = loadable(() => import('./pages/teacher-data-board-v2/class-time/class-time-teacher.jsx'), {
  fallback: <Loading />
})

const DataBoardV2DemoCardDetail = loadable(() => import('./pages/teacher-data-board-v2/demo-card-detail'), {
  fallback: <Loading />
})

//教学服务看板：点评率详情页-全部老师
const DataBoardV2ReviewRate = loadable(() => import('./pages/teacher-data-board-v2/review-rate/review-rate.jsx'), {
  fallback: <Loading />
})

//教学服务看板：点评率详情页-单个老师
const DataBoardV2ReviewRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/review-rate/review-rate-teacher.jsx'), {
  fallback: <Loading />
})

//教学服务看板：课堂满意度详情页-全部老师
const DataBoardV2ClassSatisfaction = loadable(() => import('./pages/teacher-data-board-v2/class-satisfaction/class-satisfaction.jsx'), {
  fallback: <Loading />
})

//教学服务看板：课堂满意度详情页-单个老师
const DataBoardV2ClassSatisfactionTeacher = loadable(() => import('./pages/teacher-data-board-v2/class-satisfaction/class-satisfaction-teacher.jsx'), {
  fallback: <Loading />
})

//数据看板：反馈详情页-全部下属
const DataBoardV2FeedbackRate = loadable(() => import('./pages/teacher-data-board-v2/feedback-rate/feedback-rate.jsx'), {
  fallback: <Loading />
})
//数据看板：反馈详情页-单个老师
const DataBoardV2FeedbackRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/feedback-rate/feedback-rate-teacher.jsx'), {
  fallback: <Loading />
})

//教学服务看板：准时出勤率页面-全部老师
const DataBoardV2AttendanceRate = loadable(() => import('./pages/teacher-data-board-v2/attendance-rate/attendance-rate.jsx'), {
  fallback: <Loading />
})
//教学服务看板：准时出勤率页面-单个老师
const DataBoardV2AttendanceRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/attendance-rate/attendance-rate-teacher.jsx'), {
  fallback: <Loading />
})
//教学服务看板：画作质检页面-单个老师
const DataBoardV2PaintingQualityRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/painting-quality/painting-quality-detail.jsx'), {
  fallback: <Loading />
})

//教学服务看板：画作质检页面-画作申诉
const DataBoardV2PaintingQualityAppealRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/painting-quality-appeal/painting-quality-appeal.jsx'), {
  fallback: <Loading />
})

//数据看板：课时统计详情二级页面
const DataBoardV2ClassTimeDetail = loadable(() => import('./pages/teacher-data-board-v2/class-time/detail/class-time-detail.jsx'), {
  fallback: <Loading />
})
//数据看板：点评及时率详情二级页面
const DataBoardV2ReviewRateDetail = loadable(() => import('./pages/teacher-data-board-v2/review-rate/detail/review-rate-detail.jsx'), {
  fallback: <Loading />
})
//数据看板：出勤率率详情二级页面
const DataBoardV2AttendanceRateDetail = loadable(() => import('./pages/teacher-data-board-v2/attendance-rate/detail/attendance-rate-detail.jsx'), {
  fallback: <Loading />
})
// 综合看板： 出席明细
const DataBoardV2PresenceRate = loadable(() => import('./pages/teacher-data-board-v2/presence-rate'), {
  fallback: <Loading />
})
// 综合看板： 结课续费明细页
const DataBoardV2RenewalRate = loadable(() => import('./pages/teacher-data-board-v2/renewal-rate'), {
  fallback: <Loading />
})
// 综合看板： 专题考级报名明细
const DataBoardV2SubjectRegistrationRate = loadable(() => import('./pages/teacher-data-board-v2/subject-registration-rate'), {
  fallback: <Loading />
})
// 综合看板： 专题考级报名明细
const DataBoardV2SubjectRegistrationRateTeacher = loadable(() => import('./pages/teacher-data-board-v2/subject-registration-teacher'), {
  fallback: <Loading />
})
//数据看板：课堂满意度详情二级页面
const DataBoardV2SatisfactionDetail = loadable(() => import('./pages/teacher-data-board-v2/class-satisfaction/detail/class-satisfaction-detail.jsx'), {
  fallback: <Loading />
})
//数据看板：反馈填写率详情二级页面
const DataBoardV2FeedbackRateDetail = loadable(() => import('./pages/teacher-data-board-v2/feedback-rate/detail/feedback-rate-detail.jsx'), {
  fallback: <Loading />
})

// 课程进度页
const CourseProgress = loadable(() => import('./pages/course-progress/index.jsx'), {
  fallback: <Loading />
})

// 画作详情
const PaintingDetails = loadable(() => import('./pages/painting-details/index'), {
  fallback: <Loading />
})

/**
 *  path="/" 一定要放在最后一个，不然无法匹配到他之后的path
 *
 */
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDataBoardV2: false
    }
  }
  componentDidMount() {
    this.handleDataBoardV2Routing();
    // 监听 hashchange 事件
    window.addEventListener('hashchange', () => {
      this.handleDataBoardV2Routing();
    });
    window.removeEventListener('hashchange', () => {
      this.handleDataBoardV2Routing();
    });
  }
  // 综合看板2路由监听处理
  handleDataBoardV2Routing() {
    let hash = window.location.hash;
    this.setState({
      isDataBoardV2: hash.indexOf('dataBoardV2') !== -1
    })
  }
  render() {
    const { isDataBoardV2 } = this.state;
    return (
      <div className={`App disable-compile-css-root ${isDataBoardV2 ? 'dataBoardV2PageWrapper' : ''}`}>
        <Switch>
          <Route path='/index' component={LoadableIndex} />
          <Route path='/upgradePop' component={LoadableUpgradePop} />
          <Route path='/upgradeDetail' component={LoadableUpgradeDetail} />
          <Route path='/browserDownload' component={LoadableBrowserDownload} />
          <Route path='/coursePreview' component={LoadableCoursePreview} />
          <Route path='/courseProgress' component={CourseProgress} />
          <Route path='/address' component={LoadableAddress} />
          <Route path='/courseStatus' component={LoadableCourseStatus} />
          <Route path='/preCourseStatus' component={LoadablePreCourseStatus} />
          <Route path='/teacherDataBoard' component={LoadableTeacherDataBoard} />
          <Route path='/classTime' component={LoadableClassTime} />
          <Route path='/reviewRate' component={LoadableReviewRate} />
          <Route path='/demoCardDetail' component={LoadableDemoCardDetail} />
          <Route path='/classSatisfaction' component={LoadableClassSatisfaction} />
          <Route path='/feedbackRate' component={LoadableFeedbackRate} />
          <Route path='/attendanceRate' component={LoadableAttendanceRate} />
          <Route path='/courseReview' component={LoadableCourseReview} />
          <Route path='/recordVideo' component={LoadableRecordVideo} />
          <Route path='/test' component={LoadableTest} />
          <Route path='/testV2' component={testV2} />
          <Route path='/privacyAgreement' component={LoadablePrivacyArgreement} />
          <Route path='/privacyAgreementOs' component={LoadablePrivacyArgreementOs} />
          <Route path='/privacyAgreementOversea' component={LoadablePrivacyArgreementOversea} />
          <Route path='/privacyAgreement2' component={LoadablePrivacyArgreement2} />
          <Route path='/overdue' component={LoadableOverdueActivity} />
          <Route path='/teacherList' component={LoadableTeacherList} />
          <Route path='/homeworkTransfer' component={LoadableTransferOperation} />
          <Route path='/classTimeDetail' component={LoadableClassTimeDetail} />
          <Route path='/reviewRateDetail' component={LoadableReviewRateDetail} />
          <Route path='/attendanceRateDetail' component={LoadableAttendanceRateDetail} />
          <Route path='/satisfactionDetail' component={LoadableSatisfactionDetail} />
          <Route path='/feedbackRateDetail' component={LoadableFeedbackRateDetail} />
          <Route path='/classSuggestion' component={LoadableSuggestion} />
          <Route path='/networkTest' component={LoadableNetWorkTest} />
          <Route path='/liveAdminVideo' component={LoadableLiveAdminRecordVideo} />
          <Route path='/courseTimeDetail' component={LoadableCourseTime} />
          <Route path='/courseTimeDetail2' component={LoadableCourseTimeDetail} />
          <Route path='/courseTimeDetailRule' component={LoadableCourseTimeRule} />
          <Route path='/coursewareViewer' component={coursewareViewer} />
          <Route path='/coursewareFullScreen' component={coursewareFullScreen} />
          <Route path='/coursewareFullScreenToWord' component={coursewareFullScreenToWord} />
          <Route path='/excellentHomework' component={ExcellentHomework} />
          <Route path='/addressV2' component={addressV2} />
          <Route path='/customerService' component={customerService} />
          {/* <Route path='/userAgreement' component={userAgreement} /> */}
          <Route path='/coupon' component={coupon} />
          <Route path='/parentsClass' component={parentsClass} />
          <Route path='/userAgreement' component={userAgreement} />
          <Route path='/userAgreementOversea' component={userAgreementOversea} />
          <Route path='/commonQuestion' component={commonQuestion} />
          <Route path='/expandZone/entry' component={expandZoneEntry} />
          <Route path='/expandZone/ofterPage' component={expandZoneOfter} />
          <Route path='/app-test' component={appTestPage} />
          <Route path='/apptest' component={appTestPage} />
          <Route path='/imageTemplate' component={ImageTemplatePage} />

          {expandZoneHomeRoutes()}
          <Route path='/guideBindWxServer/vip' component={guideBindPageToVip} />
          <Route path='/guideBindWxServer/member' component={guideBindPageToMember} />
          <Route path='/appDownload' component={AppDownload} />
          <Route path='/serviceAgreement' component={ServiceAgreement} />

          {/* 新版画啦啦点评app数据看板 */}
          <Route path='/dataBoardV2/home' component={DataBoardV2TeacherDataBoard} />
          <Route path='/dataBoardV2/studentMessage' component={DataBoardV2StudentMessage} />
          <Route path='/dataBoardV2/table' component={DataBoardV2TableDemo} />
          <Route path='/dataBoardV2/presenceRate' component={DataBoardV2PresenceRate} />
          <Route path='/dataBoardV2/presenceRateTeacher' component={DataBoardV2PresenceRate} />
          <Route path='/dataBoardV2/renewalRate' component={DataBoardV2RenewalRate} />
          <Route path='/dataBoardV2/renewalRateTeacher' component={DataBoardV2RenewalRate} />
          <Route path='/dataBoardV2/subjectRegistrationRate' component={DataBoardV2SubjectRegistrationRate} />
          <Route path='/dataBoardV2/subjectRegistrationRateTeacher' component={DataBoardV2SubjectRegistrationRateTeacher} />
          <Route path='/dataBoardV2/classMessage' component={DataBoardV2ClassMessage} />
          <Route path='/dataBoardV2/classMessageTeacher' component={DataBoardV2ClassMessageTeacher} />
          <Route path='/dataBoardV2/classTime' component={DataBoardV2ClassTime} />
          <Route path='/dataBoardV2/classTimeTeacher' component={DataBoardV2ClassTimeTeacher} />
          <Route path='/dataBoardV2/reviewRate' component={DataBoardV2ReviewRate} />
          <Route path='/dataBoardV2/reviewRateTeacher' component={DataBoardV2ReviewRateTeacher} />
          <Route path='/dataBoardV2/demoCardDetail' component={DataBoardV2DemoCardDetail} />
          <Route path='/dataBoardV2/classSatisfaction' component={DataBoardV2ClassSatisfaction} />
          <Route path='/dataBoardV2/classSatisfactionTeacher' component={DataBoardV2ClassSatisfactionTeacher} />
          <Route path='/dataBoardV2/feedbackRate' component={DataBoardV2FeedbackRate} />
          <Route path='/dataBoardV2/feedbackRateTeacher' component={DataBoardV2FeedbackRateTeacher} />
          <Route path='/dataBoardV2/attendanceRate' component={DataBoardV2AttendanceRate} />
          <Route path='/dataBoardV2/attendanceRateTeacher' component={DataBoardV2AttendanceRateTeacher} />
          <Route path='/dataBoardV2/classTimeDetail' component={DataBoardV2ClassTimeDetail} />
          <Route path='/dataBoardV2/reviewRateDetail' component={DataBoardV2ReviewRateDetail} />
          <Route path='/dataBoardV2/attendanceRateDetail' component={DataBoardV2AttendanceRateDetail} />
          <Route path='/dataBoardV2/satisfactionDetail' component={DataBoardV2SatisfactionDetail} />
          <Route path='/dataBoardV2/feedbackRateDetail' component={DataBoardV2FeedbackRateDetail} />
          <Route path='/dataBoardV2/paintingQuality' component={DataBoardV2PaintingQualityRateTeacher} />
          <Route path='/dataBoardV2/paintingQualityAppeal' component={DataBoardV2PaintingQualityAppealRateTeacher} />
          <Route path='/paintingDetails' component={PaintingDetails} />
          <Route path='/' component={NoFound} />
        </Switch>
      </div>
    );
  }
}

export default App;